export const GOOGLE_API_KEY = 'AIzaSyAagrP53sRmtqd6lrrQnLTpCvwYZV1W8WI'
